import { useEffect } from "react";

import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { EventTrackType, trackEvent } from "@is/services/EventTracking";

export const useProcessPendingEvents = () => {
  useEffect(() => {
    const storedTrackEvent = LocalStorageService.getItem(
      LocalStorageKeys.TrackEvents
    );

    if (storedTrackEvent) {
      const trackEventParsed = JSON.parse(storedTrackEvent);

      trackEventParsed.forEach((trackEventItem: EventTrackType) => {
        trackEvent(trackEventItem);
      });

      LocalStorageService.removeItem(LocalStorageKeys.TrackEvents);
    }
  }, []);
};
